const isNull = (variable) => {
    if (variable === null || variable === undefined || variable === "") return true
    return false
}

//const functions = 
export { isNull }

